import { apiClient } from "api/client";

function unwrap(e) {
  return {
    success: false,
    error: e?.response?.data?.error || e.message,
  };
}

export async function adminLoginApi({ id, password }) {
  try {
    const { data } = await apiClient.post("/admin/login", { id, password });
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function getAdminDashboardApi() {
  try {
    const { data } = await apiClient.get("/admin/dashboard");
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function getAdminStatisticsApi() {
  try {
    const { data } = await apiClient.get("/admin/statistics");
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function getAdminUserApi(docId) {
  try {
    const { data } = await apiClient.get(`/admin/user/${encodeURIComponent(docId)}`);
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function getAdminMatchApi(docId) {
  try {
    const { data } = await apiClient.get(`/admin/match/${encodeURIComponent(docId)}`);
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function getAdminServiceApi(docId) {
  try {
    const { data } = await apiClient.get(`/admin/service/${encodeURIComponent(docId)}`);
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function getAdminCommunityApi(docId) {
  try {
    const { data } = await apiClient.get(`/admin/community/${encodeURIComponent(docId)}`);
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function answerAdminServiceApi(docId, comment) {
  try {
    const { data } = await apiClient.post(
      `/admin/service/${encodeURIComponent(docId)}/answer`,
      { comment },
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

// ────────── 목록 ──────────

export async function listAdminUsersApi(params = {}) {
  try {
    const { data } = await apiClient.get("/admin/users", { params });
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function listAdminMatchesApi(params = {}) {
  try {
    const { data } = await apiClient.get("/admin/matches", { params });
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function listAdminServicesApi(params = {}) {
  try {
    const { data } = await apiClient.get("/admin/services", { params });
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function listAdminCommunitiesApi(params = {}) {
  try {
    const { data } = await apiClient.get("/admin/communities", { params });
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

// ────────── 커뮤니티 관리 ──────────

export async function updateAdminCommunityApi(docId, payload) {
  try {
    const { data } = await apiClient.put(
      `/admin/community/${encodeURIComponent(docId)}`,
      payload,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function deleteAdminCommunityApi(docId) {
  try {
    const { data } = await apiClient.delete(
      `/admin/community/${encodeURIComponent(docId)}`,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function listAdminCommunityCommentsApi(docId) {
  try {
    const { data } = await apiClient.get(
      `/admin/community/${encodeURIComponent(docId)}/comments`,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function deleteAdminCommentApi(docId) {
  try {
    const { data } = await apiClient.delete(
      `/admin/comment/${encodeURIComponent(docId)}`,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

// ────────── 회원/매칭 관리 ──────────

export async function updateAdminUserPointApi(docId, point) {
  try {
    const { data } = await apiClient.put(
      `/admin/user/${encodeURIComponent(docId)}/point`,
      { point },
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function deleteAdminUserApi(docId) {
  try {
    const { data } = await apiClient.delete(
      `/admin/user/${encodeURIComponent(docId)}`,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function restoreAdminUserApi(docId) {
  try {
    const { data } = await apiClient.post(
      `/admin/user/${encodeURIComponent(docId)}/restore`,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function deleteAdminMatchApi(docId) {
  try {
    const { data } = await apiClient.delete(
      `/admin/match/${encodeURIComponent(docId)}`,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

// ────────── 신고 ──────────

export async function listAdminReportsApi(params = {}) {
  try {
    const { data } = await apiClient.get("/admin/reports", { params });
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function deleteAdminReportApi(docId) {
  try {
    const { data } = await apiClient.delete(
      `/admin/report/${encodeURIComponent(docId)}`,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

// ────────── 차단 ──────────

export async function listAdminBlocksApi(params = {}) {
  try {
    const { data } = await apiClient.get("/admin/blocks", { params });
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function deleteAdminBlockApi(docId) {
  try {
    const { data } = await apiClient.delete(
      `/admin/block/${encodeURIComponent(docId)}`,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

// ────────── 포인트 거래 ──────────

export async function listAdminPointsApi(params = {}) {
  try {
    const { data } = await apiClient.get("/admin/points", { params });
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

// ────────── 공지사항 ──────────

export async function listAdminNoticesApi(params = {}) {
  try {
    const { data } = await apiClient.get("/admin/notices", { params });
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function createAdminNoticeApi(payload) {
  try {
    const { data } = await apiClient.post("/admin/notice", payload);
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function updateAdminNoticeApi(docId, payload) {
  try {
    const { data } = await apiClient.put(
      `/admin/notice/${encodeURIComponent(docId)}`,
      payload,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

export async function deleteAdminNoticeApi(docId) {
  try {
    const { data } = await apiClient.delete(
      `/admin/notice/${encodeURIComponent(docId)}`,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

// ────────── 평점 ──────────

export async function listAdminRatingsApi(params = {}) {
  try {
    const { data } = await apiClient.get("/admin/ratings", { params });
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

// ────────── 메타 / DISTINCT 타입 ──────────

export async function listAdminTypesApi(kind) {
  try {
    const { data } = await apiClient.get(
      `/admin/types/${encodeURIComponent(kind)}`,
    );
    return data || { success: false };
  } catch (e) {
    return unwrap(e);
  }
}

// ────────── CSV 내보내기 ──────────

export function adminExportUrl(kind) {
  return `/api/admin/export/${encodeURIComponent(kind)}`;
}
